    import axios from "axios";
    import baseUrl from "..";
    import { authToken, authUserID, axiosInstance } from "../axiosConfig";


    const listVisualInspectionPlates = async (page : any, pageSize: any, inspectionStatus: any, keyword: any, batchCode: any, lotCode:any, sort?: any, order?:any) => {
        try {
        const response = await axiosInstance.get(`${baseUrl}/lots/list_lots?page=${page}&size=${pageSize}&sort=${sort}&order=${order}&inspection_status=${inspectionStatus}&keyword=${keyword}&batch_no=${batchCode}&lot_code=${lotCode}`,
        {
            headers: {
            'x-auth-token': authToken,
            'x-userid': authUserID
            }
        });
        return response.data;
        } catch (error) {
        if (axios.isAxiosError(error)) {
            return error.response?.data
        }
        }
    };


    const listLotCodeMainPage = async (batchCode: any) => {
      try {
      const response = await axiosInstance.get(`${baseUrl}/lots/list_lots?&sort=id&order=desc&inspection_status=failed,passed&batch_no=${batchCode}`,
      {
          headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
          }
      });
      return response.data;
      } catch (error) {
      if (axios.isAxiosError(error)) {
          return error.response?.data
      }
      }
    };


    const listInspectionReasons = async () => {
      try {
      const response = await axiosInstance.get(`${baseUrl}/master/list_inspection_reasons?page=1&size=10&sort=id&order=desc`,
      {
          headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
          }
      });
      return response.data;
      } catch (error) {
      if (axios.isAxiosError(error)) {
          return error.response?.data
      }
      }
    };


    const saveVisualInspection = async (dataToSend:any) => {
        try {
          const response = await axiosInstance.post(`${baseUrl}/plates/save_visual_inspection`, dataToSend ,{
            headers: {
              'x-auth-token': authToken,
              'x-userid': authUserID
            }
          }
          );
          return response.data;
        } catch (error) {
          if (axios.isAxiosError(error)) {
            return error.response?.data
          }
        }
      };

  
    const saveLotVisualInspection = async (dataToSend:any) => {
      try {
        const response = await axiosInstance.post(`${baseUrl}/plates/save_visual_inspection`, dataToSend ,{
          headers: {
            'x-auth-token': authToken,
            'x-userid': authUserID
          }
        }
        );
        return response.data;
      } catch (error) {
        if (axios.isAxiosError(error)) {
          return error.response?.data
        }
      }
    };


    const listFilterLots = async (batchNo?: string) => {
        try {
        const response = await axiosInstance.get(`${baseUrl}/lots/list_lots?&sort=id&order=desc&inspection_status=failed,passed,pending,Not required&batch_no=${batchNo || ""}`,
        {
            headers: {
            'x-auth-token': authToken,
            'x-userid': authUserID
            }
        });
        return response.data;
        } catch (error) {
        if (axios.isAxiosError(error)) {
            return error.response?.data
        }
        }
    };


    const getPlateDetailsByLotId = async (lotId:any) => {
      try {
        const response = await axiosInstance.get(`${baseUrl}/lots/view_lot?lot_id=${lotId}`,
        {
            headers: {
            'x-auth-token': authToken,
            'x-userid': authUserID
            }
        });
        return response.data;
        } catch (error) {
        if (axios.isAxiosError(error)) {
            return error.response?.data
        }
        }
    };


    const getPlateDetailsByLotCode = async (LotCode:any) => {
      try {
        const response = await axiosInstance.get(`${baseUrl}/lots/list_lots?page=1&size=10&sort=id&order=asc&status=active&keyword=&inspection_status=pending&batch_no=&lot_code=${LotCode}`,
        {
            headers: {
            'x-auth-token': authToken,
            'x-userid': authUserID
            }
        });
        return response.data;
        } catch (error) {
        if (axios.isAxiosError(error)) {
            return error.response?.data
        }
        }
    };


    const getPlateDetailsByVisualInspectionLotCode = async (LotCode:any , batchCode:string, lotId: string) => {
      try {
        const response = await axiosInstance.get(`${baseUrl}/lots/list_lots_for_visual_inspection?sort=id&order=asc&status=active&inspection_status=pending&lot_code=${LotCode}&batch_no=${batchCode}&lot_ids=${lotId}`,
        {
            headers: {
            'x-auth-token': authToken,
            'x-userid': authUserID
            }
        });
        return response.data;
        } catch (error) {
        if (axios.isAxiosError(error)) {
            return error.response?.data
        }
        }
    };


    const listLotByLotCode = async (lotCode: any) => {
      try {
      const response = await axiosInstance.get(`${baseUrl}/lots/list_lots?page=1&size=10&sort=id&order=asc&status=active&keyword=&inspection_status=pending&batch_no=&lot_code=${lotCode}`,
      {
          headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
          }
      });
      return response.data;
      } catch (error) {
      if (axios.isAxiosError(error)) {
          return error.response?.data
      }
      }
    };

    const ListActions = async () => {
      try {
      const response = await axiosInstance.get(`${baseUrl}/action/list?sort=id&status=active,inactive&order=asc&id=`,
      {
          headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
          }
      });
      return response.data;
      } catch (error) {
      if (axios.isAxiosError(error)) {
          return error.response?.data
      }
      }
    };





const visualInspection= {
    listVisualInspectionPlates,
    saveVisualInspection,
    listLotCodeMainPage,
    listFilterLots,
    saveLotVisualInspection,
    listInspectionReasons,
    getPlateDetailsByLotId,
    listLotByLotCode,
    getPlateDetailsByLotCode,
    ListActions,
    getPlateDetailsByVisualInspectionLotCode
  };
  
  export { visualInspection };